import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FormField } from "@/components/stock/FormField";
import { toast } from "sonner";

const PwInput = ({ label, value, onChange, testid }) => (
  <FormField label={label}>
    <Input type="password" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
  </FormField>
);

function PasswordDialog({ open, onClose, title, withCurrent, onSubmit, prefix }) {
  const { t } = useLang();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  useEffect(() => { if (open) setF({ current: "", next: "", confirm: "" }); }, [open]);
  const submit = async () => {
    if (f.next.length < 6) return toast.error(t("password_min"));
    if (f.next !== f.confirm) return toast.error(t("password_mismatch"));
    try {
      await onSubmit(f);
      toast.success(t("password_changed"));
      onClose();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid={`${prefix}-dialog`}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {withCurrent && <PwInput label={t("current_password")} value={f.current} onChange={(v) => setF({ ...f, current: v })} testid={`${prefix}-current-input`} />}
          <PwInput label={t("new_password")} value={f.next} onChange={(v) => setF({ ...f, next: v })} testid={`${prefix}-new-input`} />
          <PwInput label={t("confirm_password")} value={f.confirm} onChange={(v) => setF({ ...f, confirm: v })} testid={`${prefix}-confirm-input`} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid={`${prefix}-cancel-btn`}>{t("cancel")}</Button>
          <Button onClick={submit} className="bg-slate-900 hover:bg-slate-800" data-testid={`${prefix}-save-btn`}>{t("save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export const ChangePasswordDialog = ({ open, onClose }) => {
  const { t } = useLang();
  return (
    <PasswordDialog open={open} onClose={onClose} title={t("change_password")} withCurrent prefix="change-password"
      onSubmit={(f) => api.post("/auth/change-password", { current_password: f.current, new_password: f.next })} />
  );
};

export const ResetPasswordDialog = ({ target, onClose }) => {
  const { t } = useLang();
  return (
    <PasswordDialog open={!!target} onClose={onClose} title={`${t("reset_password")} · ${target?.email || ""}`} prefix="reset-password"
      onSubmit={(f) => api.put(`/users/${target.id}/password`, { password: f.next })} />
  );
};
